<template>
  <div class="space-y-2 divide-y divide-gray-900/10">
    <div v-for="propGroup in themePropGroups" class="pt-4 pb-2 grid grid-cols-1 gap-8 lg:grid-cols-4">
      <div class="relative px-4 sm:px-0">
        <div>
          <h2 class="text-base font-semibold leading-7 text-gray-900">{{ propGroup.title }}</h2>
          <p class="mt-1 text-sm leading-6 text-gray-600">{{ propGroup.description }}</p>
        </div>
      </div>

      <div class="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl lg:col-span-3">
        <div class="px-4 py-2">
          <div class="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-6 sm:grid-cols-6">
            <StdPropEditor
              v-for="prop in propGroup.props"
              :model-value="getThemePropByName(prop.name)"
              :key="prop.name"
              :prop-def="prop"
              :class="[getPropLayoutClasses(prop)]"
              @update:model-value="
                (newValue) => {
                  botsStore.setThemePropByName(prop.name, newValue);
                }
              "
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { storeToRefs } from 'pinia';
  import { useBotsStore } from '@/store/BotsStore';
  import { BOT_THEME_TYPE_DEFS } from '@/spec/BotThemeTypeDefs';
  import StdPropEditor from '@/components/Editors/StdPropEditor.vue';

  const botsStore = useBotsStore();
  const { getThemePropByName } = storeToRefs(botsStore);

  const themePropGroups = BOT_THEME_TYPE_DEFS['default'].propGroups;

  const propLayoutClassesByType = {
    text: 'col-span-full',
    boolean: 'col-span-full',
    number: 'sm:col-span-full md:col-span-full lg:col-span-3 xl:col-span-2',
    string: 'sm:col-span-full md:col-span-full lg:col-span-3',
    color: 'sm:col-span-full md:col-span-full lg:col-span-3',
    select: 'sm:col-span-full md:col-span-full lg:col-span-3',
    selectLong: 'col-span-full',
    stringLong: 'col-span-full',
    csvAlphaNumeric: 'col-span-full',
    audioFile: 'col-span-full',
    transcriptsCollection: 'col-span-full',
    recordingsCollection: 'col-span-full',
    kpiCollection: 'col-span-full',
    categoriesCollection: 'col-span-full',
    temperature: 'col-span-full',
    separator: 'col-span-full',
    logo: 'col-span-full',
  };

  function getPropLayoutClasses(prop) {
    return propLayoutClassesByType[prop?.type] || '';
  }
</script>
